import React from "react";
import CardContainer from "../cardContainer";
import VehicleRouteCardContent from "./vehicleRouteCardContent";
import { VehicleTripSegment } from "../../../models/vehicle/vehicleTripSegment";

interface VehicleRouteCardProps {
    tripSegment: VehicleTripSegment;
    isSelected: boolean;
    onClick: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    stopIndex: number;
}

const VehicleRouteCard: React.FC<VehicleRouteCardProps> = ({
    tripSegment,
    isSelected,
    onClick,
    onMouseEnter,
    onMouseLeave,
    stopIndex,
}) => {
    return (
        <CardContainer
            isSelected={isSelected}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <VehicleRouteCardContent
                tripSegment={tripSegment}
                stopIndex={stopIndex}
            />
        </CardContainer>
    );
};

export default VehicleRouteCard;